const NAMESPACE = 'USER_INFO_DATA';

const MARK_AS_NEW_ACCOUNT = `${NAMESPACE}/MARK_AS_NEW_ACCOUNT`;
const UPDATE_BILLING_ADDRESS = `${NAMESPACE}/UPDATE_BILLING_ADDRESS`;
const UPDATE_USER_NAME = `${NAMESPACE}/UPDATE_USER_NAME`;
const SET_LOGGED_IN = `${NAMESPACE}/SET_LOGGED_IN`;
const SET_LOGGED_OUT = `${NAMESPACE}/SET_LOGGED_OUT`;
const SET_TICKET_DOWNLOAD_URL = `${NAMESPACE}/SET_TICKET_DOWNLOAD_URL`;
const SET_USER_ORDERS = `${NAMESPACE}/SET_USER_ORDERS`;
const UPDATE_USER_ORDER = `${NAMESPACE}/UPDATE_USER_ORDER`;

export {
    MARK_AS_NEW_ACCOUNT,
    SET_LOGGED_IN,
    SET_LOGGED_OUT,
    SET_TICKET_DOWNLOAD_URL,
    SET_USER_ORDERS,
    UPDATE_BILLING_ADDRESS,
    UPDATE_USER_NAME,
    UPDATE_USER_ORDER,
};

export default NAMESPACE;
